import Image from "components/image/image.component";
import { format } from "date-fns";

import "./chat-box.style.scss";

const ChatBox = ({ chat, isSelected }) => {
	const { numberOfUnreads, name, lastMessage } = chat;
	const {
		message,
		date,
		// senderId
	} = lastMessage;

	// let initials = name.split(" ");
	// initials = initials[0][0] + initials[initials.length - 1][0];

	// const colorIndex = name[0] < "I" ? 0 : name[0] < "R" ? 1 : 2;
	// const imageBackground = IMAGE_COLORS[colorIndex];

	return (
		<div className={`size400 chat-box ${isSelected && "selected"}`}>
			<div className="left">
				<Image name={name} />
				{/* <div className={`image-wrapper ${imageBackground}`}>{initials}</div> */}
			</div>
			<div className="middle">
				<div className="name">{name}</div>
				<div className="message">{message}</div>
			</div>
			<div className="right">
				{date && <div className="date">{format(new Date(date), "dd/MM/yyyy")}</div>}
				{numberOfUnreads !== null && numberOfUnreads > 0 && (
					<div className="unreads">{numberOfUnreads}</div>
				)}
			</div>
		</div>
	);
};

export default ChatBox;
